import cleanup from './cleanup-ms'
import placement from './placement-ms'

/** Piawaian lukisan seperti yang dikuatkuasakan oleh semakan (pelan DS). Placeholder sama dengan drawing-en.ts. */
export default {
  drawingStandard: {
    title: 'Piawaian lukisan: {{profile}}',
    intro:
      'Semakan membaca lukisan dengan ketat berdasarkan piawaian ini. Nama lapisan mesti sepadan tepat (huruf besar atau kecil tidak diambil kira); nama lain tidak diterima.',
    layersTitle: 'Lapisan',
    required: 'Wajib',
    optional: 'Pilihan',
    roles: {
      site_boundary: 'Tepat satu polyline tertutup atau hatch: sempadan tapak. Tiada apa-apa lagi pada lapisan ini.',
      landuse:
        'Setiap plot sebagai polyline tertutup atau hatch tersendiri, di dalam tapak. Garisan terbuka di dalam tapak menyebabkan semakan gagal.',
      labels:
        'Teks biasa satu baris (TEXT) di dalam setiap plot, yang tertulis tepat satu daripada nama kelas guna tanah di bawah.',
      context: 'Butiran sokongan jika berkaitan (kontur, saliran, bangunan sedia ada). Tidak disemak.',
      ignored: 'Apa-apa lagi yang diperlukan oleh pelan. Dibaca dan diabaikan.',
    },
    hintsOnly:
      'Jika nama lapisan hampir sama dengan nama dalam piawaian, laporan semakan menamakan lapisan yang betul sebagai petunjuk sahaja; lukisan tetap gagal sehingga lapisan itu dinamakan semula.',
    rulesTitle: 'Peraturan untuk keseluruhan lukisan',
    rules: {
      modelSpace: 'Lukis semuanya dalam model space. Layout (paper space) tidak dibaca.',
      units: 'Lukis dalam meter, pada koordinat sebenar sistem koordinat yang anda pilih ({{crs}}).',
      noBlocks: 'Tiada blok pada lapisan wajib: explode dahulu. Kandungan blok tidak dibaca.',
      closure: 'Sempadan tapak mesti tertutup: jurang melebihi {{tolerance}} m akan gagal.',
      area: 'Luas yang diisytiharkan (hektar) mesti sepadan dengan luas sempadan tapak dalam lingkungan {{pct}}%.',
      format: 'Simpan sebagai DWG daripada AutoCAD 2000 hingga 2018, atau sebagai DXF.',
    },
    classesTitle: 'Nama kelas guna tanah untuk teks label',
    classesHint:
      'Setiap label mesti tertulis salah satu nama ini sepenuhnya. Huruf besar atau kecil tidak diambil kira; teks lain tidak mengelaskan plot.',
    template: 'Muat turun templat yang mematuhi piawaian (DXF)',
    templateHint:
      'Tapak contohnya seluas {{hectares}} ha dan diletakkan pada kedudukan sementara: lukis tapak anda sendiri pada koordinat sebenarnya.',
    templateHintPlaced:
      'Tapak contohnya berukuran {{hectares}} ha dan dibuka di tempat yang anda klik: lukis tapak anda sendiri pada koordinat sebenarnya.',
    pick: {
      open: 'Buka templat di tapak saya',
      hint: 'Pilihan. Klik tapak anda pada peta dan templat dibuka di situ, dalam sistem koordinat yang anda pilih. Ia hanya titik permulaan: lukis tapak anda sendiri pada koordinat sebenarnya.',
      unavailable:
        'Pemasangan ini tidak dapat meletakkan templat pada peta di sini, jadi ia dibuka pada kedudukan pemegang tempatnya.',
      map: 'Peta untuk memilih tapak anda',
      click: 'Klik tapak anda pada peta.',
      placed: 'Templat dibuka di {{x}}, {{y}} dalam EPSG:{{srid}}.',
      failed:
        'Tempat itu tidak dapat dibaca dalam EPSG:{{srid}}. Klik di dalam kawasan yang diliputi sistem koordinat ini.',
      clear: 'Kosongkan',
    },
  },
  findingHelp: {
    layerAbsent:
      'Tiada lapisan dalam lukisan bernama {{layer}}. Nama lapisan mesti sepadan tepat; huruf besar atau kecil tidak diambil kira.',
    layerUnusable:
      'Lapisan {{layer}} wujud tetapi tidak mengandungi apa-apa yang boleh digunakan oleh semakan dalam model space.',
    layerExact: 'Nama lapisan mesti sepadan tepat; huruf besar atau kecil tidak diambil kira.',
    nearMiss:
      'Lapisan "{{near}}" kelihatan seperti {{layer}}, tetapi ia tidak dibaca: namakan semula kepada {{layer}} tepat.',
    holds: {
      site_boundary: '{{layer}} mesti mengandungi tepat satu polyline tertutup atau hatch: sempadan tapak.',
      landuse: '{{layer}} mesti mengandungi setiap plot sebagai polyline tertutup atau hatch.',
      labels: '{{layer}} mesti mengandungi teks biasa yang menamakan kelas guna tanah di dalam setiap plot.',
      context: '{{layer}} boleh mengandungi apa-apa butiran sokongan.',
      ignored: '{{layer}} boleh mengandungi apa-apa; ia tidak dibaca.',
    },
    unknownMore: '…dan {{more}} lagi yang tidak disenaraikan di sini.',
    unknownExpected: 'Lapisan dalam piawaian ialah: {{expected}}.',
    paperSpace: 'Hanya model space dibaca; apa-apa dalam layout (paper space) diabaikan.',
    oneLayer:
      'Semua dalam model space berada pada satu lapisan, "{{layer}}". Letakkan sempadan tapak, plot dan label masing-masing pada lapisan piawaiannya sendiri.',
    noClosedShapes:
      'Garisannya terbuka. Lukis setiap plot sebagai polyline tertutup atau hatch; garisan terbuka tidak dikira sebagai plot.',
    plotsDropped:
      'Tiada satu pun bentuk tertutupnya menghasilkan plot di dalam tapak: bentuk itu terletak di luar tapak, hanya menyentuh sempadannya, atau tidak dapat dibaiki. Lukis setiap plot sebagai bentuk tertutup tersendiri di dalam tapak.',
    openLines:
      'Lukis setiap plot pada {{layer}} sebagai polyline tertutup atau hatch: tutup setiap garisan terbuka menjadi garis luar plotnya, atau padamkannya.',
    crsFitsOne:
      'Lukisan anda kelihatan berada dalam {{crs}}. Semak dalam perisian CAD anda, tukar CRS yang diisytiharkan dan serahkan semula.',
    crsFitsSeveral:
      'Lukisan anda akan berada di dalam bidang kuasa dalam mana-mana sistem ini: {{list}}. Semak dalam perisian CAD anda sistem yang digunakan, tukar CRS yang diisytiharkan dan serahkan semula.',
    crsFitsNone:
      'Tiada sistem koordinat yang ditawarkan meletakkan tapak di dalam bidang kuasa. Semak bahawa lukisan berada pada koordinat sebenarnya, bukan koordinat tempatan berhampiran 0,0, dan serahkan semula.',
    crsCheck:
      'Semak dalam perisian CAD anda sistem koordinat lukisan dan bahawa ia berada pada koordinat sebenarnya. Isytiharkan sistem itu dan serahkan semula.',
    landedAt:
      'Apabila dibaca dalam EPSG:{{srid}}, pusat tapak berada di {{x}}, {{y}}: longitud {{longitude}}, latitud {{latitude}}.',
    unitsCheck:
      'Lukisan dibaca dalam meter. Semak unitnya dalam perisian CAD anda, skalakan kepada meter jika ia dalam unit lain, dan serahkan semula.',
    areaCompare: 'Bandingkan sempadan tapak dengan keluasan pada borang, betulkan yang salah dan serahkan semula.',
    areaCentimetres:
      'Tapak berukuran kira-kira 10,000 kali keluasan yang diisytiharkan. Salah satu mungkin dalam unit yang salah: borang meminta hektar, dan lukisan dalam sentimeter juga memberikan hasil ini. Semak dahulu angka yang diisytiharkan. Skalakan lukisan kepada meter hanya jika angka itu betul, kemudian serahkan semula.',
    areaMillimetres:
      'Tapak berukuran kira-kira 1,000,000 kali keluasan yang diisytiharkan. Salah satu mungkin dalam unit yang salah: borang meminta hektar, dan lukisan dalam milimeter juga memberikan hasil ini. Semak dahulu angka yang diisytiharkan. Skalakan lukisan kepada meter hanya jika angka itu betul, kemudian serahkan semula.',
    areaFeet:
      'Tapak berukuran kira-kira 10.8 kali keluasan yang diisytiharkan. Salah satu mungkin dalam unit yang salah: borang meminta hektar, dan lukisan dalam kaki juga memberikan hasil ini. Semak dahulu angka yang diisytiharkan. Skalakan lukisan kepada meter hanya jika angka itu betul, kemudian serahkan semula.',
    areaSquareMetres:
      'Angka yang diisytiharkan kelihatan dalam meter persegi: ia kira-kira 10,000 kali keluasan tapak yang diukur. Borang meminta hektar, jadi semak dan masukkannya dalam hektar (satu hektar ialah 10,000 meter persegi), kemudian serahkan semula.',
    datumCheck:
      'Semakan tidak dapat membezakan grid ini daripada lukisan sahaja. Tanya penyedia lukisan datum yang digunakan, dan isytiharkan sistem koordinat itu.',
    noJurisdiction:
      'Tiada apa-apa untuk dibetulkan dalam lukisan bagi perkara ini. Tanpa sempadan, sistem koordinat yang salah tidak dapat dikesan di sini, jadi semak sistem yang anda isytiharkan dalam perisian CAD anda.',
  },
  nextStep: {
    title: 'Langkah seterusnya: muat naik lukisan yang dibetulkan',
    body: 'Lukisan tidak lulus semakan. Betulkan setiap kegagalan dalam laporan semakan, kemudian muat naik lukisan yang dibetulkan sebagai versi seterusnya bagi penyerahan ini.',
    upload: 'Muat naik lukisan yang dibetulkan',
  },
  checkWording: { conversionLabel: 'Penukaran' },
  placement,
  cleanup,
} as const
